import type { SearchInfoData } from '@/app/search/types.ts';
import type { InitialParams } from '@/app/components/hotel-detail/InitialParamsProvider.tsx';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { getTransportCompanyAndRouteParams } from '@/app/components/hotel-detail/common/tracking.ts';
import { getTrackingVcSearchId } from '@/app/common/tracking/trackingUtils.ts';
import type { OffersData } from '@/app/components/hotel-detail/OffersProvider.tsx';
import type { ClickToCheckoutBasePayload } from './clickToCheckout.ts';

export const DETAIL_BOOK_CLICKED = 'DETAIL_BOOK_CLICKED';
export const DETAIL_BOOK_CLICKED_VERSION = '1.1';

export type DetailBookClickedPayload = ClickToCheckoutBasePayload;

export type DetailBookClickedParams = {
  searchParams: SearchParams;
  searchInfoData: SearchInfoData;
  initialParams: InitialParams;
  offersData: OffersData | undefined;
  actionId: string;
  selectedMealPlan: MealPlanType;
  roomId: string;
  /** Overrides initialParams.flightClickId when the id is generated in the same click
   *  (the provider state update is not readable yet) — see useTrackEvoBookClicked. */
  flightClickId?: string;
};

export const createDetailBookClickedPayload = ({
  searchParams,
  searchInfoData,
  initialParams,
  offersData,
  actionId,
  selectedMealPlan,
  roomId,
  flightClickId,
}: DetailBookClickedParams): DetailBookClickedPayload => {
  const { searchId } = searchInfoData;
  const vcSearchId = searchParams[URLParameters.VC_SEARCH_ID];

  return {
    searchId: searchId || '',
    productDetailKey: initialParams.productDetailKey,
    actionId,
    internalHotelId: Number(initialParams.internalHotelId),
    providerId: selectedMealPlan.supplier?.id?.toString(),
    desiredProfitPricingId: selectedMealPlan.dynamicPricingId,
    mealPlanClass: selectedMealPlan.boardClass,
    optionIndex: Number(selectedMealPlan.index || 0),
    roomId,
    vcSearchId: getTrackingVcSearchId(offersData, vcSearchId),
    ...getTransportCompanyAndRouteParams(offersData?.transport?.transports?.[0]),
    flightClickId: flightClickId || initialParams.flightClickId || '',
    clickId: searchParams[URLParameters.CLICK_ID] || '',
  };
};
